import BaseModelAPI from '../BaseModelAPI';

export default class AttachmentPartPurchaseQualityControlList extends BaseModelAPI {

	static entity = 'attachmentpartpurchasequalitycontrollist'
	static entityName = 'attachmentpartpurchasequalitycontrol';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
